import { useCallback, useEffect, useState } from 'react'
import lodash from 'lodash'
import BackOfficeAPIClient from "../../../clients/BackofficeAPIClient"
import { Societe } from "../../../types/Societe"
import { Activite } from "../../../types/Activite"

interface UseActivitesDisponiblesReturn {
    activites: Activite[]
    loading: boolean
}

/**
 * Activités effectivement présentes dans le groupe (déduites des sociétés), pour filtrer plus
 * tard les onglets/blocs à n'afficher que ce qui concerne les activités du groupe.
 */
const useAvailableActivities = (): UseActivitesDisponiblesReturn => {
    const apiClient = new BackOfficeAPIClient()
    const [activites, setActivites] = useState<Activite[]>([])
    const [loading, setLoading] = useState<boolean>(true)

    const fetchActivites = useCallback(async () => {
        setLoading(true)
        try {
            const [societes, toutesActivites] = await Promise.all([
                apiClient.get<Societe[]>('/societes'),
                apiClient.get<Activite[]>('/activites'),
            ])

            const idsActivitesDuGroupe = lodash.uniq(societes.map(s => s.IDActivite))
            setActivites(toutesActivites.filter(a => idsActivitesDuGroupe.includes(a.IDActivite)))
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        fetchActivites()
    }, [fetchActivites])

    return { activites, loading }
}

export default useAvailableActivities
